import Main from "@/layouts/main"
import { useLoaderData } from "react-router-dom"

export default function Profile() {
    const data = useLoaderData()

    return (
        <Main title="Profile" headerTitle="Profile">
            <div className="divide-y">
                <div className="p-6">
                    <div className="flex items-center justify-between">
                        <div>
                            <h2 className="text-lg font-semibold">{data.name}</h2>
                            <p className="text-neutral-500">{data.email}</p>
                        </div>
                        <div className="relative">
                            <img className="w-24 h-24 border rounded-2xl" src={`https://ui-avatars.com/api/?name=${data.name}`} alt={`${data.name}'s Profile Picture`} />
                        </div>
                    </div>
                </div>
            </div>
        </Main>
    )
}